'use strict';

function SelectRegistry () {

  this._registry = {};

  this.register = function (id, select) {
    this._registry[id] = select;
  };

  this.get = function (id) {
    return this._registry[id];
  };

  this.remove = function (id) {
    delete this._registry[id];
  };
}

SelectRegistry.$inject = [];
module.exports = SelectRegistry;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/form/src/select/SelectRegistry.js